import { useEffect, useState } from "react";
import CountUp from "react-countup"

export const IncrementValue = ({
    value,
    duration = 0.5
}: { value: number, duration?: number }) => {
    const [previousValue, setPreviousValue] = useState(0)

    useEffect(() => {
        setTimeout(() => {
            setPreviousValue(value)
        }, 1000);
    }, [value])
    return (
        <CountUp
            start={previousValue}
            end={value}
            prefix="R$ "
            decimals={2}
            decimal=","
            separator="."
            duration={duration}
        />
    )
}